import { defineComponent } from '@digitalbranch/app'

import template from './top-app-bar-medium.html'
import css from './top-app-bar-medium.css'

export const uiTopAppBarMedium = defineComponent({
  name: 'ui-top-app-bar-medium',
  template,
  css,
})
